export default __webpack_public_path__ + "static/media/pictures_framing.7a0382b2.JPG";